// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__U9jb9","footer__link":"Footer_footer__link__ANpql"};